import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { Wallet } from "lucide-react";

import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  getMyPayouts,
  MentorPayoutsKeys,
} from "@/features/payouts/api/mentor-payouts";
import { formatCurrency } from "@/utils/currencies";

const MyPayoutsTable = () => {
  const { data = [], isLoading } = useQuery({
    queryKey: [MentorPayoutsKeys.GET_MY_PAYOUTS],
    queryFn: getMyPayouts,
  });

  if (isLoading) {
    return (
      <div className="space-y-4">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="flex items-center gap-4">
            <Skeleton className="h-10 w-full" />
          </div>
        ))}
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <Wallet className="h-5 w-5 text-[#767677]" />
        <div className="mt-2 text-[#767677] text-sm font-semibold">
          No payouts yet
        </div>
      </div>
    );
  }

  return (
    <Table bordered={false}>
      <TableHeader className="bg-transparent">
        <TableRow>
          <TableHead className="px-3 py-1.5 text-[10px] font-semibold tracking-[-0.4px] text-[#767677]">
            Amount
          </TableHead>
          <TableHead className="px-3 py-1.5 text-[10px] font-semibold tracking-[-0.4px] text-[#767677]">
            Paid On
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((payout) => (
          <TableRow
            key={payout.payoutId}
            className="hover:bg-sds-neutral-00 transition-colors"
          >
            <TableCell className="px-3 py-1.5 text-[12px] tracking-[-0.48px] text-[#494949] font-semibold">
              {formatCurrency(payout.amountUsd)}
            </TableCell>
            <TableCell className="px-3 py-1.5 text-[10px] tracking-[-0.4px] text-[#494949]">
              {format(new Date(payout.createdAt), "MMM dd, yyyy")}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MyPayoutsTable;
